import React, { useEffect, useState } from "react";
import moment from "moment";

import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";

import { useNavigate, useParams } from "react-router-dom";
import GoBack from "../../../component/molecules/goBack";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import RedBtn from "../../../component/atoms/button/redBtn";
import Checkbox from "../../../component/atoms/input/checkbox";
import PretendardText from "./../../../component/atoms/text/pretendardText";
import GrayBtn from "./../../../component/atoms/button/grayBtn";
import styled from "styled-components";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import { errorHandler } from "../../../util/errorHandler";
import Modal from "../../../component/templates/Modal";

import GroupApi from "../../../api/group.api";
import MemberApi from "../../../api/member.api";
import AdminGroupManagePopup from "../../../component/templates/user/userAdmin/adminGroupManagePopup";
import { route } from "../../../router/route";

const UserAdminDetail = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_admin)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [selectedGroupValue, setSelectedGroupValue] = useState();
  const [operateGroupList, setOperateGroupList] = useState([]);

  const [userInfo, setUserInfo] = useState();
  const [selectedGroupIdList, setSelectedGroupIdList] = useState([]);

  const [groupPopupOpen, setGroupPopupOpen] = useState(false);
  const [buttonGroupFilterOpen, setButtonGroupFilterOpen] = useState(false);

  useEffect(() => {
    getOperateGroupList();

    getUserInfoFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (selectedGroupValue) {
      setGroupPopupOpen(true);
    }
  }, [selectedGroupValue]);

  const getUserInfoFunc = async () => {
    try {
      const response = (await MemberApi.getDetail(id)).data.data.content;

      setUserInfo(response);

      if (response?.groupList && response?.groupList.length > 0) {
        let temp = response?.groupList.map((group) => group.id);

        setSelectedGroupIdList(temp);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // 운영진 그룹 가져오기
  const getOperateGroupList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        memberGroupType: "OPERATE",
      };

      const response = (await GroupApi.getList(data)).data.data.content;
      setOperateGroupList(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const createGroupFunc = async () => {
    try {
      const data = {
        memberIds: [id],
        groupIds: selectedGroupIdList,
      };

      await MemberApi.adminCreateGroup(data);

      getUserInfoFunc();
      toast(toastMsg.create);

      setSelectedGroupIdList([]);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 삭제 관련 ---------- //
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      let data = {
        memberIds: [id],
      };
      await MemberApi.managerDelete(data);

      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {isWriteAuthority && (
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
              >
                {/* 버튼 그룹 - 그룹지정 */}
                <div
                  style={{
                    height: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <GrayBtn
                    onClick={() => {
                      setButtonGroupFilterOpen(!buttonGroupFilterOpen);
                    }}
                  >
                    그룹지정
                  </GrayBtn>
                  {buttonGroupFilterOpen && (
                    <FilterWrapper
                      style={{
                        width: 230,
                        top: 36,
                        padding: 16,
                      }}
                    >
                      {operateGroupList.length > 0
                        ? operateGroupList.map((item, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: 10,
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  if (
                                    selectedGroupIdList.some(
                                      (item02) => item02 === item.id
                                    )
                                  ) {
                                    let groupIdListTemp =
                                      selectedGroupIdList.filter(
                                        (item02) => item02 !== item.id
                                      );

                                    setSelectedGroupIdList(groupIdListTemp);
                                  } else {
                                    setSelectedGroupIdList([item.id]);
                                  }
                                }}
                              >
                                <PretendardText
                                  style={{
                                    fontWeight: "500",
                                    fontSize: "13px",
                                    lineHeight: "21.5px",
                                    color: selectedGroupIdList.some(
                                      (item02) => item02 === item.id
                                    )
                                      ? "rgba(181, 181, 181, 0.5)"
                                      : "#aaa",
                                  }}
                                >
                                  {item.title}
                                </PretendardText>
                                {selectedGroupIdList.some(
                                  (item02) => item02 === item.id
                                ) && (
                                  <img
                                    src="/assets/admin/icons/ico_select_checked.svg"
                                    alt="선택됨"
                                    style={{
                                      width: 18,
                                      height: 18,
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })
                        : null}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: 10,
                          borderTop: "0.5px solid rgba(255, 255, 255, 0.12)",
                        }}
                      >
                        <PretendardText
                          onClick={() => {
                            setSelectedGroupValue({
                              id: 0,
                            });
                          }}
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "21.5px",
                            color: "rgba(181, 181, 181, 0.5)",
                            cursor: "pointer",
                          }}
                        >
                          새 그룹 만들기
                        </PretendardText>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          justifyContent: "flex-end",
                        }}
                      >
                        <GrayBtn
                          style={{}}
                          onClick={() => {
                            createGroupFunc();

                            setButtonGroupFilterOpen(false);
                          }}
                        >
                          적용
                        </GrayBtn>
                      </div>
                    </FilterWrapper>
                  )}
                </div>
                <RedBtn
                  style={{
                    backgroundColor: "#272829",
                  }}
                  onClick={() => {
                    setDeleteModalOpen(true);
                  }}
                >
                  운영진 삭제
                </RedBtn>
              </div>
            )}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                회원 상세 내역
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* 이름 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    이름
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.name}</DetailFormText>
                </DetailPageForm>
                {/* 아이디(이메일) */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    아이디(이메일)
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.email}</DetailFormText>
                </DetailPageForm>
                {/* 닉네임 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    닉네임
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.nickname}</DetailFormText>
                </DetailPageForm>
                {/* 핸드폰 번호 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    핸드폰 번호
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.nickname.replace(
                      /(\d{3})(\d{4})(\d{4})/,
                      "$1-$2-$3"
                    )}
                  </DetailFormText>
                </DetailPageForm>
                {/* 운영진 그룹 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    운영진 그룹
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.groupList && userInfo?.groupList?.length > 0
                      ? userInfo.groupList.map((group, index02) => {
                          return (
                            <span key={index02}>
                              {group.title}
                              {index02 !== userInfo.groupList.length - 1 &&
                                ", "}
                            </span>
                          );
                        })
                      : "그룹 없음"}
                  </DetailFormText>
                </DetailPageForm>
                {/* 운영진 초대일 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    운영진 초대일
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.inviteDate
                      ? moment(userInfo?.inviteDate).format("YYYY-MM-DD")
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 운영진 수락일 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    운영진 수락일
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.inviteConfirmDate
                      ? moment(userInfo?.inviteConfirmDate).format("YYYY-MM-DD")
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 마지막 접속 날짜 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    마지막 접속 날짜
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.lastLoginDate
                      ? moment(userInfo?.lastLoginDate).format("YYYY-MM-DD")
                      : ""}
                  </DetailFormText>
                </DetailPageForm>
                {/* 약관 동의 */}
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                    border: "none",
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    약관 동의
                  </DetailFormTitle>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Checkbox
                      checked={userInfo?.receiveAgreement}
                      onChange={() => {}}
                    />
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 14,
                        lineHeight: "21px",
                        color: "#999",
                      }}
                    >
                      혜택 및 이벤트 등 서비스 알림 수신에 동의합니다(선택)
                    </PretendardText>
                  </div>
                </DetailPageForm>
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {/* 그룹 정보 수정 팝업 */}
      {groupPopupOpen && (
        <AdminGroupManagePopup
          setPopupOpen={setGroupPopupOpen}
          selectedGroupValue={selectedGroupValue}
          getOperateGroupList={getOperateGroupList}
        />
      )}

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}
    </>
  );
};

export default UserAdminDetail;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;
